<template>
    <div class="list">
      <div class="dataItem" v-for="(item,index) in sjzUserData" :key="index" @click.prevent="toCode(index)">
        <div class="message">
          <div class="textMsg">
            <p style="width: 250px;white-space: normal">{{item.userName}}</p>
            <p>性别： {{item.sexRadio}}</p>
            <p>身份证： {{item.idCard}}</p>
          </div>
          <div class="code">
            <img :src="codeImg" alt="">
          </div>
        </div>
        <div class="button">
          <el-button @click="toCode(index)">查看详情</el-button>
        </div>
      </div>
      <div class="buttonAdd">
        <el-button type="primary"
                   style="width: 200px;
                          position: relative;
                          top: 50%;
                          transform: translateY(-50%);"
                    @click="toAdd">+ 添加其他人</el-button>
      </div>
    </div>
</template>

<script>
    import  storage from '../../model/storage.js'
    export default {
      name: "sjzList",
      data() {
        return {
          sjzUserData: [],
          codeImg: domain.imgUrl+'qr/code.png'
        }
      },
      created() {
        this.sjzUserData = storage.get('sjzUserData')

      },
      methods: {
        toCode(index) {
          this.$router.push({
            path: '/sjz_code',
            name: 'sjzCodePage',
            query: {
              index: index
            }
          })
        },
        toAdd() {
          this.$router.push({
            path: '/sjz_form',
            name: 'sjzFormIndex',
            query: {
              on: 1
            }
          })
        }
      }
    }
</script>

<style scoped>

  .list {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 80px;

  }
  .dataItem {
    position: relative;
    margin-top: 30px;
    border-top: .17067rem solid #3897f0;
    border-radius: .21333rem;
    box-shadow: 0 0 0.42667rem 0 rgba(6,1,2,.1);
    padding: .59733rem .576rem .68267rem .64rem;
    width: 90%;
  }
  .message {
    border-bottom: 1px dashed #cccccc;
  }
  .code {
    position: absolute;
    right: 10px;
    top: 20px;
    width: 55px;
    height: 55px;

  }
  .code img {
    width: 55px;
    height: 55px;
  }
  .button {
    margin-top: 10px;
  }
  .buttonAdd {
    position: fixed;
    bottom: 0;
    height: 60px;
    width: 100%;
    background-color: #fff;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/sjz/sjzList.vue